import { createStore } from 'vuex'
import accessory from './modules/accessory'
import auth from './modules/auth'
import cooldown from './modules/cooldown'
import conditioningtype from './modules/conditioningtype'
import division from './modules/division'
import equipments from './modules/equipments'
import events from './modules/events'
import menuStore from './modules/menu'
import metcon from './modules/metcon'
import movements from './modules/movements'
import notifications from './modules/users'
import program from './modules/program'
import strength from './modules/strength'
import subscriptions from './modules/subscriptions'
import users from './modules/users'
import warmup from './modules/warmup'
import workout from './modules/workout'


const store = createStore({
	modules: {
		accessory,
		auth,
		cooldown,
		conditioningtype,
		division,
		equipments,
		events,
		menuStore,
		metcon,
		movements,
		notifications,
		program,
		strength,
		subscriptions,
		users,
		warmup,
		workout
	}
});

export default store;






